<script>
import transportLuggageConceptTypes from '../../variables/transportLuggageConceptTypes';

export default {
  name: 'NonDynamicTransportLuggageRow',
  props: {
    luggage: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      default: null,
    },
    luggageTypes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showCommentModal: false,
      transportLuggageConceptTypes,
    };
  },
  methods: {
    update(attribute, value) {
      this.$emit('update', { index: this.index, attribute, value });
    },
    updateLuggageConcept(event) {
      this.update('concept', event);
    },
    updateLuggageType(event) {
      if (typeof event === 'undefined') {
        this.update('transportLuggageTypeId', null);
      } else {
        this.update('transportLuggageTypeId', event.id);
      }
    },
    updateLuggageAmount(event) {
      return event.length ? this.update('amount', +event) : this.update('amount', null);
    },
    updateLuggageWeight(event) {
      return event.length ? this.update('weight', +event) : this.update('weight', null);
    },
    updateLuggageHeight(event) {
      return event.length ? this.update('height', +event) : this.update('height', null);
    },
    updateLuggageLength(event) {
      return event.length ? this.update('length', +event) : this.update('length', null);
    },
    updateLuggageWidth(event) {
      return event.length ? this.update('width', +event) : this.update('width', null);
    },
    updateInclusive(event) {
      this.update('inclusive', event);
    },
    updateLuggageComment(event) {
      return event.length ? this.update('comment', event) : this.update('comment', null);
    },
    updateLuggageOddType(event) {
      this.update('oddType', event);
    },
    updateLuggagePrice(event) {
      this.update('price', +event);
    },
  },
};
</script>

<template>
  <v-container>
    <v-radio-group
      :value="luggage.concept"
      @change="updateLuggageConcept($event)"
    >
      <v-layout row>
        <v-radio
          :value="transportLuggageConceptTypes.PIECE_CONCEPT"
          :label="$t('nonDynamicTransport.labels.pieceConcept')"
        />
        <v-radio
          class="pb-2"
          :value="transportLuggageConceptTypes.WEIGHT_CONCEPT"
          :label="$t('nonDynamicTransport.labels.weightConcept')"
        />
      </v-layout>
    </v-radio-group>
    <v-layout row>
      <v-flex xs5>
        <v-select
          :items="luggageTypes"
          :value="luggage.transportLuggageTypeId"
          :label="$t('nonDynamicTransport.labels.chooseType')"
          item-text="name"
          item-value="id"
          class="mr-2"
          solo
          clearable
          return-object
          @change="updateLuggageType"
        />
      </v-flex>
      <v-flex xs1>
        <v-text-field
          :value="luggage.amount"
          :label="$t('nonDynamicTransport.labels.pieces')"
          class="mr-2"
          solo
          @input="updateLuggageAmount"
        />
      </v-flex>
      <v-flex xs2>
        <v-text-field
          :value="luggage.weight"
          :label="$t('nonDynamicTransport.labels.weight')"
          class="mr-2"
          solo
          @input="updateLuggageWeight"
        />
      </v-flex>
      <v-flex xs2>
        <v-text-field
          :value="luggage.height"
          :label="$t('nonDynamicTransport.labels.height')"
          class="mr-2"
          solo
          @input="updateLuggageHeight"
        />
      </v-flex>
      <v-flex xs2>
        <v-text-field
          :value="luggage.length"
          :label="$t('nonDynamicTransport.labels.length')"
          class="mr-2"
          solo
          @input="updateLuggageLength"
        />
      </v-flex>
      <v-flex xs2>
        <v-text-field
          :value="luggage.width"
          :label="$t('nonDynamicTransport.labels.width')"
          class="mr-2"
          solo
          @input="updateLuggageWidth"
        />
      </v-flex>
      <v-flex xs2>
        <v-text-field
          :value="luggage.price"
          class="mr-2"
          label="Price"
          solo
          @input="updateLuggagePrice"
        />
      </v-flex>
      <v-flex>
        <v-dialog
          v-model="showCommentModal"
          persistent max-width="300"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              class="mb-4 table-icon"
              v-on="on"
              fab
              small
              color="primary"
            >
              <v-icon v-on="on" dark>info</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ $t('nonDynamicTransport.labels.information') }}</span>
            </v-card-title>
            <v-card-text>
              <v-text-field
                :value="luggage.comment"
                :label="$t('nonDynamicTransport.labels.comment')"
                solo
                @input="updateLuggageComment"
              />
            </v-card-text>
            <v-divider class="mr-2 ml-2"/>
            <v-card-actions>
              <v-spacer/>
              <v-btn
                color="success"
                @click="showCommentModal = false"
              >
                {{ $t('buttons.save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-flex>
        <v-checkbox
          class="mt-2 mr-3"
          :input-value="luggage.inclusive"
          :label="$t('nonDynamicTransport.labels.inclusive')"
          @change="updateInclusive"
        />
      </v-flex>
      <v-flex>
        <v-checkbox
          class="mt-2 mr-3"
          :input-value="luggage.oddType"
          :label="$t('nonDynamicTransport.labels.odd')"
          @change="updateLuggageOddType"
        />
      </v-flex>
      <v-flex>
        <v-icon
          class="mt-2"
          color="success"
          size="40"
          @click="$emit('add', index)"
        >
          add_box
        </v-icon>
      </v-flex>
      <v-flex>
        <v-icon
          class="mt-2"
          color="error"
          size="40"
          @click="$emit('delete', index)"
        >
          delete
        </v-icon>
      </v-flex>
    </v-layout>
    <v-divider class="pr-2 pl-2"/>
  </v-container>
</template>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportLuggageRow.vue